import React from "react";
import { connect } from "react-redux";

import {
  doGetAllCompanies,
  doCreateCompany,
  doUpdateCompany,
  doGetAllPartnerCompanies,
  doCreatePartnerCompany,
  doUpdatePartnerCompany,
} from "../stores/thunk";
import { selectAllCompanies } from "../stores/slice";
import { selectAllPartners } from "../../partner/stores/slice";
import { doGetAllPartners } from "../../partner/stores/thunk";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      isFetching: state.company.isFetching,
      metadata: state.company.metadata,
      companies: selectAllCompanies(state),
      partners: selectAllPartners(state),
    };
  }

  return connect(mapStateToProps, {
    doGetAllCompanies,
    doCreateCompany,
    doUpdateCompany,
    doGetAllPartnerCompanies,
    doCreatePartnerCompany,
    doUpdatePartnerCompany,
    doGetAllPartners,
  })(Container);
};
